export const iconSizes = {
    xs: 16,
    small: 20,
    medium: 24,
    large: 32,
    xl: 48,
};
